export function isRunningOnWorker() {
    /* eslint-disable-next-line @typescript-eslint/ban-ts-comment  -- (https://aka.ms/OWALintWiki)
     * Acceptable to run within the worker */
    // @ts-ignore - TypeScript treats WorkerGlobalScope as a type only
    return typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope;
}
